// Schema.org JSON-LD builders + runtime injection (kept separate from meta tag mutation).

import { getSiteUrl, SITE_FAVICON } from "@/lib/seo";

export interface ArticleSchemaInput {
  title: string;
  description: string;
  url: string;
  image?: string;
  lang: string;
}

export function buildWebSiteSchema(lang: string) {
  const origin = getSiteUrl();
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "AllChinaBuy Spreadsheet Resource Center",
    url: `${origin}/`,
    inLanguage: lang,
    publisher: {
      "@type": "Organization",
      name: "AllChinaBuy Spreadsheet Resource Center",
      logo: {
        "@type": "ImageObject",
        url: SITE_FAVICON,
      },
    },
    potentialAction: {
      "@type": "SearchAction",
      target: `${origin}/?q={search_term_string}`,
      "query-input": "required name=search_term_string",
    },
  };
}

export function buildArticleSchema(input: ArticleSchemaInput) {
  const schema: Record<string, unknown> = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: input.title,
    description: input.description,
    url: input.url,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": input.url,
    },
    inLanguage: input.lang,
    author: {
      "@type": "Organization",
      name: "AllChinaBuy Spreadsheet Team",
    },
    publisher: {
      "@type": "Organization",
      name: "AllChinaBuy Spreadsheet Resource Center",
      logo: {
        "@type": "ImageObject",
        url: SITE_FAVICON,
      },
    },
    datePublished: "2026-08-24",
    dateModified: "2026-08-24",
  };

  if (input.image) {
    schema.image = [input.image];
  }

  return schema;
}

const JSONLD_PREFIX = "route-jsonld-";

export function injectSchemas(schemas: object[]) {
  document
    .querySelectorAll<HTMLScriptElement>(`script[id^="${JSONLD_PREFIX}"]`)
    .forEach((script) => script.remove());

  schemas.forEach((schema, index) => {
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = `${JSONLD_PREFIX}${index}`;
    el.textContent = JSON.stringify(schema);
    document.head.appendChild(el);
  });
}